/**
 * @generated SignedSource<<ae23a6d6919799135b1ee59fc95c28bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersCheckIsMorningStudioArticle$data = {
  readonly articleTypes: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId: string;
    } | null> | null;
  } | null> | null;
  readonly sponsorType: string | null;
  readonly " $fragmentType": "helpersCheckIsMorningStudioArticle";
};
export type helpersCheckIsMorningStudioArticle$key = {
  readonly " $data"?: helpersCheckIsMorningStudioArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsMorningStudioArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersCheckIsMorningStudioArticle"
};

(node as any).hash = "d33f7c516dcb2e9aafe1c67c69fcb697";

export default node;
